import React, { Component, useState, useCallback, useEffect  } from "react";
import { useSelector, useDispatch, useStore } from 'react-redux';

import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';


import Box from '@mui/material/Box';

import List from '@mui/material/List';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';

import ListItemText from '@mui/material/ListItemText';

import TextField from '@mui/material/TextField';

import InputAdornment from '@mui/material/InputAdornment';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import AddBoxIcon from '@mui/icons-material/AddBox';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LaunchIcon from '@mui/icons-material/Launch';
import LockIcon from '@mui/icons-material/Lock';
import CheckIcon from '@mui/icons-material/Check';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import InputLabel from '@mui/material/InputLabel';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


import { MessageHooks } from "../../App";
import { UserInfo, netGet, netPost, netFetch, keycloak } from "../network";

import { setRuntimeList, setRuntimeInstance,  setRuntimeNode, setRuntimeExpandedKeys } from "../../features/menu/menuSlice";
import { RoleMemberDialog } from "../acl/management-roles";

const COLOR_MY_LOCK = 'green';
const COLOR_OTHER_LOCK = '#cc0000';
const COLOR_CHILD_LOCK = '#e0d910'; // '#e6df19';

const MAX_SCROLL_TIMER_COUNT = 8;
var scrollTimerCount = 0;



function WorkflowStartDialog(props) {
    const {
        title = 'Create Workflow Instance',
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [instance, setInstance] = useState('');
    const [docList, setDocList] = useState([]);
    const [partList, setPartList] = useState([]);
    const [roleList, setRoleList] = useState([]); // all roles including virtual
    const [roleMemberMap, setRoleMemberMap] = useState({});
    const [document, setDocument] = useState(null);
    const [docid, setDocid] = useState('');
    const [partid, setPartid] = useState('');
    const [part, setPart] = useState(null);
    const [workflowList, setWorkflowList] = useState([]);
    const [fullWorkflowList, setFullWorkflowList] = useState([]);
    const [defName, setDefName] = useState('');
    const [workflow, setWorkflow] = useState(null);
    const [okEnabled, setOkEnabled] = useState(false);
    const [roleEnabled, setRoleEnabled] = useState(false);
    const [roleDialogOpen, setRoleDialogOpen] = useState(false);
    const [wroles, setWroles] = useState([]);
    const [notPublishedDialogOpen, setNotPublishedDialogOpen] = useState(false);
    const [missingRefs, setMissingRefs] = useState([]);

    React.useEffect( () => {
        setName('');
        setDescription('');
        setInstance('');
        setDocid('');
        setPart(null);
        setPartid('');
        setPartList([]);
        setDocument(null);
        setDefName('');
        setWorkflow(null);
        setOkEnabled(false);
        setRoleEnabled(false);
        setWroles([]);
        setRoleList([]);
        setRoleMemberMap({});
        setRoleDialogOpen(false);
        setMissingRefs([]);
        setNotPublishedDialogOpen(false);
        if ( open ) {
            loadInstances();
            loadDocuments();
            loadRoles();
        }
    },[open]);

    const loadInstances = () => {
        netGet('/api/workflow/def/list?categ=DEF&pmask=2' )
            .then(response => response.json())
            .then(defs => {
                if ( defs && Array.isArray(defs) ) {
                    console.log('Workflow Definitions: ' + defs.length);
                    setWorkflowList(defs);
                }
                netGet('/api/workflow/def/list?categ=DEFS')
                    .then(response => response.json())
                    .then(fdefs => {
                        if (defs && Array.isArray(fdefs)) {
                            // console.log('Workflow Definitions: ' + defs.length);
                            setFullWorkflowList(fdefs);
                        }
                    });
            }).catch( error => {
                console.log('Error loading available workflows: ' + error);
            });
    };

    const loadDocuments = () => {
        netGet('/api/doc/roots?sort=alpha')
            .then(response => response.json())
            .then(docs => {
                if (Array.isArray(docs)) {
                    // console.log('Got ' + docs.length + ' documents.');
                    setDocList(docs);
                }
            }).catch(error => {
                console.log('Error fetching document list: ' + error);
            });
    };

    const loadRoles = (docName) => {
        netGet('/api/auth/aroles?g=0&v=1')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Status: ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data)) {
                    //console.log('roles: ' + JSON.stringify(data));
                    setRoleList(data);
                } else {
                    setRoleList([]);
                }
            }).catch(error => {
                console.log('Error: ' + error);
                setRoleList([]);
            });
    };

    const workflowTargetsValid = (wf, wmissing, wstash) => {
        if ( wstash ) {
            wstash[wf.name] = true;
        }
        console.log('valid: ' + wf.name);
        if (Array.isArray(wf.steps)) {
            wf.steps.forEach(step => {
                if (Array.isArray(step.properties?.actions)) {
                    step.properties.actions.forEach(a => {
                        if (a.name === 'RUN_WORKFLOW' || a.name === 'CREATE_WORKFLOW') {
                            const wn = a.properties?.target;
                            if (wn && (!wstash || !wstash[wn]) ) {
                                const runwf = workflowList.find(w => w.name === wn);
                                if (runwf) {
                                    workflowTargetsValid(runwf, wmissing, wstash);
                                } else if ( Array.isArray(wmissing) ) {
                                    // wmissing.push(runwf.name);
                                    console.log(' wf missing: ' + wn);
                                    const fwf = fullWorkflowList.find(w => w.name === wn);
                                    if ( fwf ) {
                                        wmissing.push(fwf.label);
                                        workflowTargetsValid(fwf, wmissing, wstash);
                                    } else {
                                        wmissing.push(wn);
                                    }
                                }
                            }
                        }
                    });
                }
            });
        }
        return wmissing;
    };

    const onOKClick = () => {
        const wmissing = [];
        workflowTargetsValid(workflow, wmissing, {});
        if ( wmissing.length > 0 ) {
            setMissingRefs(wmissing);
            setNotPublishedDialogOpen(true);
        } else {
            // console.log('Create workflow: ' + workflow.label);
            if (typeof onSave === 'function') {
                onSave(name, description, instance, workflow, docid, part, roleMemberMap);
            }

        }
        
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const nameChanged = (event) => {
        setName(event.target.value);
    };

    const descriptionChanged = (event) => {
        setDescription(event.target.value);
    };

    const instanceChanged = (event) => {
        setInstance(event.target.value);
        setValid(workflow, event.target.value, docid);
    };

    const setValid = (wf, instName, doc) => {
        if ( wf && (typeof instName === 'string') && instName !== '' && (typeof doc === 'string') && doc !== '') {
            setOkEnabled(true);
        } else {
            setOkEnabled(false);
        }
    };

    const documentChanged = (event) => {
        setDocid(event.target.value);
        setValid(workflow, instance, event.target.value);
        const doc = docList.find( item => item.id === event.target.value);
        if ( doc ) {
            setDocument(doc);
            if ( doc.category?.includes('PARTED') ) {
                setPartid('');
                netGet('/api/doc/parts/' + encodeURIComponent(doc.id))
                    .then(response => response.json())
                    .then(parts => {
                        if ( Array.isArray(parts) ) {
                            setPartList(parts);
                        }
                    }).catch(error => console.log('Error retrieving document parts: ' + error));
            } else {
                setPartid(null);
            }
        }
    };

    const partChanged = (event) => {
        setPartid(event.target.value);
        const p = partList.find( item => item.number === event.target.value);
        if ( p ) {
            setPart(p);
            // console.log('selected part: ' + JSON.stringify(p));
        }
    };

    const getWorkflowVRoles = (wf, wstash) => {
        const rr = [];
        const vr = [];
        if ( wstash && wf.name) {
            wstash[wf.name] = true;
        }
        if (Array.isArray(wf.steps)) {
            wf.steps.forEach(step => {
                if (Array.isArray(step.roles)) {
                    step.roles.forEach(r => {
                        if (!rr.includes(r)) {
                            rr.push(r);
                            const role = roleList.find(ro => ro.name === r);
                            if (role?.type === 'V') {
                                vr.push(role);
                            }
                        }
                    });
                }
                if (Array.isArray(step.properties?.actions)) {
                    step.properties.actions.forEach(a => {
                        if (a.name === 'RUN_WORKFLOW' || a.name === 'CREATE_WORKFLOW') {
                            const wn = a.properties?.target;
                            if (wn && (!wstash || !wstash[wn]) ) {
                                const runwf = workflowList.find(w => w.name === wn);
                                if (runwf) {
                                    const rvr = getWorkflowVRoles(runwf, wstash);
                                    if (Array.isArray(rvr)) {
                                        rvr.forEach(r => {
                                            if ( !rr.includes(r.name) ) {
                                                rr.push(r.name);
                                                vr.push(r)
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    });
                }
            });
        }
        return vr;
    };

    const workflowChanged = (event) => {
        // console.log('Workflow def name: ' + event.target.value);
        const wf = workflowList.find( w => w.name === event.target.value);
        setWorkflow(wf);
        if ( wf ) {
            setName(wf.label);
            setDescription(wf.description);
            // setOkEnabled(true);
            setValid(wf, instance, docid);
            // console.log('Selected workflow: ' + JSON.stringify(wf));
            const vr = getWorkflowVRoles(wf, {});
            setRoleEnabled(vr.length > 0);
        } else {
            setOkEnabled(false);
            setRoleEnabled(false);
        }
        setDefName(event.target.value);
    };

    const getWorkflowRoles = (wf, wstash) => {
        const rr = [];
        if ( wstash && wf.name ) {
            wstash[wf.name] = true;
        }
        if ( Array.isArray(wf.steps) ) {
            wf.steps.forEach( step => {
                if ( Array.isArray(step.roles) ) {
                    step.roles.forEach( r => {
                        if ( !rr.includes(r) ) {
                            rr.push(r);
                        }
                    });
                    if (Array.isArray(step.properties?.actions)) {
                        step.properties.actions.forEach(a => {
                            if (a.name === 'RUN_WORKFLOW' || a.name === 'CREATE_WORKFLOW') {
                                const wn = a.properties?.target;
                                if (wn && (!wstash || !wstash[wn])) {
                                    console.log('Found RUN_WORKFLOW: ' + wn);
                                    const runwf = workflowList.find(w => w.name === wn);
                                    if (runwf) {
                                        const rwr = getWorkflowRoles(runwf, wstash);
                                        if (Array.isArray(rwr)) {
                                            rwr.forEach(r => {
                                                if (!rr.includes(r)) {
                                                    rr.push(r);
                                                }
                                            });
                                        }
                                    }
                                }
                                else {
                                    console.log('WF LOOP detected: ' + wn);
                                }
                            }
                        });
                    }
                }
            });
        }
        return rr;
    };

    const onRoleConfigClick = () => {
        const rr = getWorkflowRoles(workflow, {});
        console.log('Workflow: ' + workflow.label + ', roles = ' + JSON.stringify(rr));
        setWroles(rr);
        setRoleDialogOpen(true);
    };

    const handleRoleConfigSave = (data) => {
        setRoleDialogOpen(false);
    };

    return (
        <Dialog
            maxWidth={'1000px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 700,
                        maxHeight: 700
                        }
                    }
                }
            }
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{paddingTop: '2ex'}}>
                    <FormControl size="small" sx={{ width: '100%' }} >
                        <InputLabel shrink id="start-select-workflow-label" size="small">Workflow</InputLabel>
                        <Select
                            labelId="start-select-workflow-label"
                            id="start-select-workflow"
                            value={defName}
                            label="Workflow"
                            onChange={workflowChanged}
                            size="small"
                            displayEmpty
                            notched
                            renderValue={(selected) => {
                                if (selected === '' || selected.length === 0) {
                                    return <Typography color="textSecondary">Select workflow...</Typography>;
                                }
                                const def = workflowList.find( w => w.name === selected);
                                const label = def ? def.label : selected;
                                return label;
                            }}
                        >
                            {Array.isArray(workflowList) &&
                                workflowList.map((def) => (
                                    <MenuItem value={def.name} key={def.name}>{def.label}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Box>

                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Instance Name" value={instance} onChange={instanceChanged} size="small" fullWidth autoFocus={true} 
                        
                        />
                </Box>

                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Description" value={description} onChange={descriptionChanged} size="small" fullWidth 
                        multiline rows={5} />
                </Box>

                <Box sx={{paddingTop: '4ex'}}>
                    <FormControl size="small" sx={{ width: '100%' }} >
                        <InputLabel shrink id="start-select-doc-id-label" size="small">Context Document</InputLabel>
                        <Select
                            labelId="start-select-doc-id-label"
                            id="start-select-doc-id"
                            value={docid}
                            label="Context Document"
                            onChange={documentChanged}
                            size="small"
                            notched
                            displayEmpty
                            renderValue={(selected) => {
                                if (selected === '' || selected.length === 0) {
                                    return <Typography color="textSecondary">Select document...</Typography>;
                                }
                                const doc = docList.find( d => d.id === selected);
                                const label = doc ? doc.title : (selected === 'NONE' ? 'None' : selected);
                                return label;
                            }}
                        >
                            <MenuItem value={'NONE'} key={'NONE'}>None</MenuItem>
                            {Array.isArray(docList) &&
                                docList.map((doc, dindex) => (
                                    <MenuItem value={doc.id} key={doc.id}>{doc.title}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Box>
                {document && document.category?.includes('PARTED') &&
                    <Box sx={{ paddingTop: '4ex' }}>
                        <FormControl size="small" sx={{ width: '100%' }} >
                            <InputLabel id="start-select-part-id-label" size="small">Context Part</InputLabel>
                            <Select
                                labelId="start-select-part-id-label"
                                id="start-select-part-id"
                                value={partid}
                                label="Context Part"
                                onChange={partChanged}
                                size="small"
                                helperText="To use as default on document part operations unless a step overrides it."
                            >
                                <MenuItem value={'NONE'} key={'NONE'}>None</MenuItem>
                                {Array.isArray(partList) &&
                                    partList.map((part, dindex) => (
                                        <MenuItem value={part.number} key={part.number}>{`${part.number} ${part.title}`}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Box>
                }
                <Button onClick={onRoleConfigClick} disabled={!roleEnabled} variant="outlined" sx={{mt: '4ex'}}
                    onSave={handleRoleConfigSave}>Role Configuration...</Button>
                
                <RoleMemberDialog open={roleDialogOpen} onCancel={() => setRoleDialogOpen(false)} docId={docid} roles={wroles} onSave={handleRoleConfigSave} />
                <WorkflowNotPublishDialog open={notPublishedDialogOpen} onDismiss={() => setNotPublishedDialogOpen(false)} missing={missingRefs} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onOKClick} sx={{minWidth: '7em'}} color="success" disabled={!okEnabled}>Create</Button>
                <Button onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function WorkflowEditDialog(props) {
    const {
        title = 'Edit Workflow Instance',
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [instance, setInstance] = useState('');
    const [docList, setDocList] = useState([]);
    const [partList, setPartList] = useState([]);
    const [roleList, setRoleList] = useState([]); // all roles including virtual
    const [roleMemberMap, setRoleMemberMap] = useState({});
    const [document, setDocument] = useState(null);
    const [docid, setDocid] = useState('');
    const [partid, setPartid] = useState('');
    const [part, setPart] = useState(null);
    const [workflowList, setWorkflowList] = useState([]);
    const [defName, setDefName] = useState('');
    const [workflow, setWorkflow] = useState(null);
    const [okEnabled, setOkEnabled] = useState(false);
    const [roleEnabled, setRoleEnabled] = useState(false);
    const [roleDialogOpen, setRoleDialogOpen] = useState(false);
    const [wroles, setWroles] = useState([]);

    const selectedNode = useSelector((state) => state.runtime.instanceNode);

    React.useEffect( () => {
        setName('');
        setDescription('');
        setInstance('');
        setDocid('');
        setPart(null);
        setPartid('');
        setPartList([]);
        setDocument(null);
        setDefName('');
        setWorkflow(null);
        setOkEnabled(false);
        setWroles([]);
        setRoleList([]);
        setRoleMemberMap({});
        setRoleDialogOpen(false);
        if ( open ) {
            loadInstance();
            loadDocuments();
            loadRoles();
        }
    },[open]);

    const loadInstance = () => {
        // console.log("workflow instance: " + JSON.stringify(selectedNode?.data?.instance));
        if ( selectedNode?.data?.instance ) {
            const inst = selectedNode.data.instance;
            setInstance(inst);
            setDescription(inst.description);
            setName(inst.properties?.instanceName);
            // console.log("Name: " + JSON.stringify(inst.properties?.instanceName));
            netGet(`/api/workflow/def/${inst.definitionId}`)
                .then(response => response.json())
                .then(def => {
                    if (def) {
                        // console.log('Workflow Definitions: ' + defs.length);
                        setWorkflow(def);
                    }
                }).catch(error => {
                    console.log('Error loading workflow definition: ' + error);
                });
            if ( Array.isArray(inst.properties?.vroles) ) {
                const mmap = {};
                inst.properties.vroles.forEach( vrole => {
                    if ( Array.isArray(vrole.members) ) {
                        const mm = [];
                        vrole.members.forEach ( m => {
                            const vm = {...m};
                            vm.userId = vm.name;
                            mm.push(vm);
                        });
                        mmap[vrole.name] = mm;
                    }
                });
                setRoleMemberMap(mmap);
            }
        }
        loadDefinitions();
        /*
        netGet('/api/workflow/def/list?categ=DEF&pmask=2' )
            .then(response => response.json())
            .then(defs => {
                if ( defs && Array.isArray(defs) ) {
                    console.log('Workflow Definitions: ' + defs.length);
                    setWorkflowList(defs);
                }
            }).catch( error => {
                console.log('Error loading available workflows: ' + error);
            });
        */
    };

    const loadDefinitions = () => {
        netGet('/api/workflow/def/list?categ=DEF&pmask=2' )
            .then(response => response.json())
            .then(defs => {
                if ( defs && Array.isArray(defs) ) {
                    console.log('Workflow Definitions: ' + defs.length);
                    setWorkflowList(defs);
                }
            }).catch( error => {
                console.log('Error loading available workflows: ' + error);
            });
    };

    const loadDocuments = () => {
        netGet('/api/doc/roots?sort=alpha')
            .then(response => response.json())
            .then(docs => {
                if (Array.isArray(docs)) {
                    // console.log('Got ' + docs.length + ' documents.');
                    console.log('Documents: ' + JSON.stringify(docs));
                    setDocList(docs);
                }
                if ( selectedNode?.data?.instance ) {
                    const inst = selectedNode.data.instance;
                    const docId = inst.properties?.document;
                    if ( docId ) {
                        setDocid(docId);
                        const doc = docs.find( d => d.id === docId);
                        setDocument(doc);
                    }
                }
            }).catch(error => {
                console.log('Error fetching document list: ' + error);
            });
    };

    const loadRoles = (docName) => {
        netGet('/api/auth/aroles?g=0&v=1')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Status: ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data)) {
                    //console.log('roles: ' + JSON.stringify(data));
                    setRoleList(data);
                } else {
                    setRoleList([]);
                }
            }).catch(error => {
                console.log('Error: ' + error);
                setRoleList([]);
            });
    };

    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            const inst = {...instance};
            inst['properties'] = {...instance.properties};
            inst['properties']['persistence'] = {...instance.properties.persistence};
            if ( name ) {
                inst.properties['instanceName'] = name;
                inst.properties['persistence']['instanceName'] = name;
            }
            inst.description = description;
            if (roleMemberMap) {
                const vroles = [];
                for (var role in roleMemberMap) {
                    const mm = roleMemberMap[role];
                    const members = [];
                    mm.forEach(m => {
                        const member = { ...m };
                        if (!member.name) {
                            member.name = member.userId;
                        }
                        members.push(member);
                    })
                    const vrole = {
                        name: role,
                        members: members,
                    };
                    vroles.push(vrole);
                }
                inst.properties['vroles'] = vroles;
                inst.properties['persistence']['vroles'] = vroles;
            }
            console.log('Updated instance: ' + JSON.stringify(inst));
            onSave(inst);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const nameChanged = (event) => {
        setName(event.target.value);
        setValid(event.target.value);
    };

    const descriptionChanged = (event) => {
        setDescription(event.target.value);
        setValid(name);
    };

    const setValid = (iname) => {
        if ( typeof iname === 'string' && iname !== '' ) {
            setOkEnabled(true);
        } else {
            setOkEnabled(false);
        }
    }

    const instanceChanged = (event) => {
        setName(event.target.value);
    };

    const documentChanged = (event) => {
        setDocid(event.target.value);
        const doc = docList.find( item => item.id === event.target.value);
        if ( doc ) {
            setDocument(doc);
            if ( doc.category?.includes('PARTED') ) {
                setPartid('');
                netGet('/api/doc/parts/' + encodeURIComponent(doc.id))
                    .then(response => response.json())
                    .then(parts => {
                        if ( Array.isArray(parts) ) {
                            setPartList(parts);
                        }
                    }).catch(error => console.log('Error retrieving document parts: ' + error));
            } else {
                setPartid(null);
            }
        }
    };

    const partChanged = (event) => {
        setPartid(event.target.value);
        const p = partList.find( item => item.number === event.target.value);
        if ( p ) {
            setPart(p);
            // console.log('selected part: ' + JSON.stringify(p));
        }
    };

    /*
    const getWorkflowRoles = (wf) => {
        const rr = [];
        if ( Array.isArray(wf.steps) ) {
            wf.steps.forEach( step => {
                if ( Array.isArray(step.roles) ) {
                    step.roles.forEach( r => {
                        if ( !rr.includes(r) ) {
                            rr.push(r);
                        }
                    });
                }
            });
        }
        return rr;
    };
    */

    const getWorkflowRoles = (wf, wstash) => {
        const rr = [];
        if ( wstash && wf.name ) {
            wstash[wf.name] = true;
        }
        if ( Array.isArray(wf.steps) ) {
            wf.steps.forEach( step => {
                if ( Array.isArray(step.roles) ) {
                    step.roles.forEach( r => {
                        if ( !rr.includes(r) ) {
                            rr.push(r);
                        }
                    });
                    if (Array.isArray(step.properties?.actions)) {
                        step.properties.actions.forEach(a => {
                            if (a.name === 'RUN_WORKFLOW' || a.name === 'CREATE_WORKFLOW') {
                                const wn = a.properties?.target;
                                if (wn && (!wstash || !wstash[wn])) {
                                    console.log('Found RUN_WORKFLOW: ' + wn);
                                    const runwf = workflowList.find(w => w.name === wn);
                                    if (runwf) {
                                        const rwr = getWorkflowRoles(runwf, wstash);
                                        if (Array.isArray(rwr)) {
                                            rwr.forEach(r => {
                                                if (!rr.includes(r)) {
                                                    rr.push(r);
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    console.log('WF LOOP detected: ' + wn);
                                }
                            }
                        });
                    }
                }
            });
        }
        return rr;
    };


    const onRoleConfigClick2 = () => {
        const rr = [];
        if ( Array.isArray(workflow.steps) ) {
            workflow.steps.forEach( step => {
                if ( Array.isArray(step.roles) ) {
                    step.roles.forEach( r => {
                        if ( !rr.includes(r) ) {
                            rr.push(r);
                        }
                    });
                }
            });
        }
        // console.log('Workflow: ' + workflow.label + ', roles = ' + JSON.stringify(rr));
        setWroles(rr);
        setRoleDialogOpen(true);
    };

    const onRoleConfigClick = () => {
        const rr = getWorkflowRoles(workflow, {});
        console.log('Workflow: ' + workflow.label + ', roles = ' + JSON.stringify(rr));
        setWroles(rr);
        setRoleDialogOpen(true);
    };

    const handleRoleConfigSave = (data) => {
        setRoleDialogOpen(false);
        setOkEnabled(true);
        if ( data.roleMemberMap ) {
            setRoleMemberMap(data.roleMemberMap);
        }
    };

    return (
        <Dialog
            maxWidth={'1000px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 700,
                        maxHeight: 700
                        }
                    }
                }
            }
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{paddingTop: '2ex'}}>
                    <TextField label="Workflow" value={instance?.definitionLabel} size="small" fullWidth 
                        slotProps={{
                            input: {
                                readOnly: true
                            },
                            inputLabel: { shrink: true }
                        }} />
                </Box>

                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Instance Name" value={name} onChange={nameChanged} size="small" fullWidth autoFocus={true} 
                        helperText="Runtime instance name. It will be added to the workflow name on runtime card."
                        />
                </Box>


                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Description" value={description} onChange={descriptionChanged} size="small" fullWidth 
                        multiline rows={5} />
                </Box>

                

                <Box sx={{paddingTop: '4ex'}}>
                    <TextField label="Context Document" value={document?.title} size="small" fullWidth 
                        slotProps={{
                            input: {
                                readOnly: true
                            },
                            inputLabel: { shrink: true }
                        }} />
                </Box>
                {document && document.category?.includes('PARTED') &&
                    <Box sx={{ paddingTop: '4ex' }}>
                        <FormControl size="small" sx={{ width: '100%' }} >
                            <InputLabel id="start-select-part-id-label" size="small">Context Part</InputLabel>
                            <Select
                                labelId="start-select-part-id-label"
                                id="start-select-part-id"
                                value={partid}
                                label="Context Part"
                                onChange={partChanged}
                                size="small"
                                helperText="To use as default on document part operations unless a step overrides it."
                            >
                                <MenuItem value={'NONE'} key={'NONE'}>None</MenuItem>
                                {Array.isArray(partList) &&
                                    partList.map((part, dindex) => (
                                        <MenuItem value={part.number} key={part.number}>{`${part.number} ${part.title}`}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Box>
                }
                <Button onClick={onRoleConfigClick} variant="outlined" sx={{mt: '4ex'}}
                    onSave={handleRoleConfigSave}>Role Configuration...</Button>
                
                <RoleMemberDialog open={roleDialogOpen} onCancel={() => setRoleDialogOpen(false)} docId={docid} roles={wroles} onSave={handleRoleConfigSave} 
                    memberMap={roleMemberMap} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onOKClick} sx={{minWidth: '7em'}} color="success" disabled={!okEnabled}>Save</Button>
                <Button onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function WorkflowNotPublishDialog(props) {
    const {
        title = 'Workflow References Not Found',
        open,
        onDismiss,
        missing,
        ...other
    } = props;

     const onOKClick = () => {
        onClose();
    }

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onDismiss === 'function' ) {
            onDismiss();
        }
    };


    return (
        <Dialog
            maxWidth={'1000px'}
            open={open}
            disableRestoreFocus
            onClose={onClose}
            slotProps ={{
                paper: {
                    sx: {
                    minWidth: 600,
                    maxHeight: 700
                    }
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold', display: 'flex'}}>
                <Typography sx={{fontSize: 'inherit', fontWeight: 'inherit'}}>{'ERROR:\xa0'}</Typography>
                <Typography sx={{fontSize: 'inherit', fontWeight: 'inherit'}}>{title}</Typography>
            </DialogTitle>
            <DialogContent>

                 <Box sx={{paddingTop: '2ex'}}>
                    <Typography>The following referenced workflows are not published:</Typography>
                    <List sx={{pt: 2}}>
                        {Array.isArray(missing) && missing.map(w =>
                            <ListItem sx={{pb: 0, pt: 0}}>
                                <ListItemText primary={w} sx={{pt: 0, pb: 0}}/>
                            </ListItem>
                        )}
                    </List>
                </Box>
             </DialogContent>
            <DialogActions>
                <Button onClick={onOKClick} sx={{minWidth: '7em'}} autoFocus >Dismiss</Button>
            </DialogActions>
        </Dialog>

    );

}


function WorkflowDeleteDialog(props) {
    const {
        title = 'Delete Workflow Instance',
        open,
        onSave,
        onCancel,
        workflowIndex,
        ...other
    } = props;

    const [okEnabled, setOkEnabled] = useState(false);
    const [forceDeleteOpen, setForceDeleteOpen] = useState(false);
    const selectedNode = useSelector((state) => state.runtime.instanceNode);
    
    

    React.useEffect( () => {
        if ( selectedNode?.id) {
            setOkEnabled(true);
            // console.log('Node to delete: ' + JSON.stringify(selectedNode));
        } else {
            setOkEnabled(false);
        }
    }, [selectedNode]);

    React.useEffect( () => {
        setForceDeleteOpen(false);
    },[open]);

    

    const onOKClick = () => {
        if ( (selectedNode?.data?.status === 'OWN' || selectedNode?.data?.status === 'LCK' || selectedNode?.data?.status === 'CLD') ) {
            setForceDeleteOpen(true);
        } else if ( typeof onSave === 'function' ) {
            onSave(selectedNode);
        }
    }

    const forceDeleteSave = () => {
        if ( typeof onSave === 'function' ) {
            onSave(selectedNode);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const getDefinitionLabel = () => {
        if ( selectedNode?.data?.instance?.definitionLabel ) {
            return selectedNode.data.instance.definitionLabel;
        }
        return ' ';
    }

    const getDescription = () => {
        if ( selectedNode?.data?.instance?.description ) {
            return selectedNode.data.instance.description;
        }
        return ' ';
    };

    const getInstanceName = () => {
        if ( selectedNode?.data?.instance?.properties?.instanceName ) {
            return selectedNode.data.instance.properties.instanceName;
        }
        return ' ';
    };

    return (
        <Dialog
            maxWidth={'1000px'}
            open={open}
            disableRestoreFocus
            onClose={onClose}
            slotProps ={{
                paper: {
                    sx: {
                    minWidth: 600,
                    maxHeight: 700
                    }
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{paddingTop: '2ex'}}>
                    <TextField label="Workflow Name" size="small" fullWidth  value={getDefinitionLabel()}
                        slotProps={{
                            input: {
                                readOnly: true,
                            }
                        }} />
                </Box>

                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Description" size="small" fullWidth value={getDescription()}
                        multiline rows={3} slotProps={{
                            input: {
                                readOnly: true,
                            }
                        }} />
                </Box>

                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Instance Name"  size="small" fullWidth autoFocus={true} value={getInstanceName()}
                        slotProps={{
                            input: {
                                readOnly: true,
                            }
                        }}
                        />
                </Box>

               
                
                <Box sx={{paddingTop: '5ex'}}>
                    <Typography sx={{display: 'inline', fontWeight: 'bold'}}>Delete workflow?</Typography>
                </Box>
                <LockedWorkflowDeleteDialog open={forceDeleteOpen} workflow={selectedNode} onSave={forceDeleteSave} onCancel={onCancelClick} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onOKClick} sx={{minWidth: '7em'}} color="error" disabled={!okEnabled} autoFocus >Delete</Button>
                <Button onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function LockedWorkflowDeleteDialog (props) {
    const {
        title='Force Delete Workflow',
        open,
        onSave,
        onCancel,
        workflow,
        ...other
    } = props;

    const getDefinitionLabel = () => {
        if ( workflow?.data?.instance?.definitionLabel ) {
            return workflow.data.instance.definitionLabel;
        }
        return '';
    }

    const getInstanceName = () => {
        if ( workflow?.data?.instance?.properties?.instanceName ) {
            return workflow.data.instance.properties.instanceName;
        }
        return '';
    };

    const getWorkflowName = () => {
        const defLabel = getDefinitionLabel();
        const instName = getInstanceName();
        return instName && instName.length > 0 ? `"${defLabel}—${instName}"` : `"${defLabel}"`;
    }

    const getLabel = () => {
        let label =  Array.isArray(workflow?.data?.users) && workflow.data.users.length > 0 ?
            <React.Fragment>Workflow <Typography sx={{display: 'inline'}} color="warning">{getWorkflowName()}</Typography><Typography sx={{display: 'inline'}}> is locked by </Typography><Typography sx={{display: 'inline'}}>{workflow.data.users[0]}.</Typography></React.Fragment> : 
                <Typography sx={{display: 'inline'}}>Delete this workflow.</Typography>;
        return label;
    }

    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(workflow);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    return (
        <Dialog
            maxWidth={'600px'}
            open={open}
            disableRestoreFocus
            onClose={onClose}
            slotProps ={{
                paper: {
                    sx: {
                    minWidth: 300,
                    maxWidth: 600,
                    minHeight: 400,
                    maxHeight: 700
                    }
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{paddingTop: '2ex'}}>
                    {getLabel()}
                </Box>

                
                <Box sx={{paddingTop: '5ex', display: 'flex'}}>
                    <Typography sx={{display: 'inline', fontWeight: 'bold', fontSize: '105%'}}>Force delete?</Typography>
                </Box>
                
            </DialogContent>
            <DialogActions>
                <Button onClick={onOKClick} sx={{minWidth: '7em'}} color="error" autoFocus >Force Delete</Button>
                <Button onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );
}

const workflowTreeType = 'WF';

function WorkflowList (props) {
    const {
        onSelect,
        update,
        ...other
    } = props;

    const [workNodes, setWorkNodes] = useState([]);
    const [docList, setDocList] = useState([]);
    const [tableHeight, setTableHeight] = useState(window.innerHeight - 290);
    const [instanceUpdate, setInstanceUpdate] = useState(0);
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const selectedNode = useSelector((state) => state.runtime.instanceNode);
    const expandedKeys = useSelector((state) => state.runtime.expandedKeys);
    const dispatch = useDispatch();
    
    const CELL_PADDING = '0.8ex';

    useEffect(() => {
        updateInstances();
        // console.log('tableHeight: ' + tableHeight);
        //const el = document.querySelector('tr[aria-selected="true"]');
    },[]);

    useEffect(() => {
        updateInstances();
        // console.log('tableHeight: ' + tableHeight);
        // const el = document.querySelector('tr[aria-selected="true"]');
    },[update]);

    useEffect(() => {
        if ( typeof onSelect === 'function') {
            onSelect(selectedNode);
        }
    },[selectedNode])

    const scrollSelected = () => {
        const el = document.querySelector('tr[aria-selected="true"]');
        if (el) {
            el.scrollIntoView(false);
        } else if ( scrollTimerCount < MAX_SCROLL_TIMER_COUNT ) {
            scrollTimerCount = scrollTimerCount + 1;
            setTimeout(scrollSelected, 500);
        } else {
            console.log("Timeout expired: could not find selected tree node...");
        }
    };

    const updateInstances = () => {
        // console.log('Fetching workflow instances... ' + reload);
        const uri = '/api/workflow/inst/find/tree'+ (workflowTreeType === 'WF' ? '?sort=WF' : '?sort=DOC');
        netGet(uri)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Status: ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                // console.log("WorkNodes: " + JSON.stringify(data));
                setWorkNodes(data);
                dispatch(setRuntimeNode(null));
                setSelectedNodeKey(null);

            }).catch(error => {
                console.log('Error: ' + error);
            });
        
    };


    const drawtable = () => {
        /*
        return (
            <TreeTable value={workNodes} tableStyle={{ width: '100%' }} emptyMessage={<span></span>}
                    selectionMode="single" selectionKeys={selectedNodeKey} onSelectionChange={handleSelectedNode} metaKeySelection={false} scrollable scrollHeight="250px">
                    <Column field="name" header={itemHeaderLabel} alignHeader="left" style={{ padding: 0, paddingLeft: '1ex', textAlign: 'left', width: '70%' }}
                        headerStyle={{ padding: '0.9ex', width: '70%', fontSize: '90%' }} expander ></Column>
                    <Column field="def" header="Default Value" align="center" headerStyle={{ padding: '0.9ex', fontSize: '90%' }}></Column>
                    <Column field="other" header="Other Field" align="center" headerStyle={{ padding: '0.9ex', fontSize: '90%' }}></Column>
                </TreeTable>
        );
        */
    };

    const handleSelectedNodeKey = (event) => {
        // console.log('Selected Node: ' + JSON.stringify(event) );
        // console.log('Selected Node other: ' + JSON.stringify(other) );
        if ( event.value ) {
            setSelectedNodeKey(event.value);
        }
    };

    const handleSelectedNode = (event) => {
        // console.log('Selected Node: ' + JSON.stringify(event.node) );
        dispatch(setRuntimeNode(event.node));
    }

    const handleToggleNode = (event) => {
        dispatch(setRuntimeExpandedKeys(event.value));
    }

    const openInstance = (node) => {
        const winst = node?.data?.instance;
        if ( node?.data?.type === 'INST' && winst ) {
            setSelectedNodeKey(node.key);
            dispatch(setRuntimeNode(node));
            /*
            setInstanceUpdate( instanceUpdate => instanceUpdate + 1);
            
            const i = instanceUpdate + 1;
            WorkflowFrontModule.pageChange(<WorkflowInstance instance={winst} update={i} />);
            dispatch(setWorkNode(node));
            dispatch(setWorkList({showList: true, listValue: false}));
            dispatch(setWorkInstance({showInstance: false, instanceValue: true}));
            */
        }
    };

    const toggleNode = (node) => {
        let xkeys = expandedKeys ? { ...expandedKeys} : {};
        if ( xkeys[node.key]) {
            delete xkeys[node.key];
        } else {
            xkeys[node.key] = true;
        }
        dispatch(setRuntimeExpandedKeys(xkeys));
    };

    const actionTemplate = (node,options) => {
        return (
            node?.data?.type === 'INST' && 
            <Box sx={{padding: 0}}>
                    <Tooltip title="Open Workflow">
                        <IconButton aria-label="open" color="primary" sx={{ padding: 0 }} onClick={() => openInstance(node)} size="small">
                            <LaunchIcon />
                        </IconButton>
                    </Tooltip>
            </Box>
        );
    };

    const statusTemplate = (node,options) => {
        let label =  Array.isArray(node?.data?.users) && node.data.users.length > 0 ?
            'Assigned to ' + node.data.users[0] : '';
        if ( node?.data?.status === 'CLD' ) {
            label = 'Child items assigned';
        }
        const color = node?.data?.status === 'OWN' ? COLOR_MY_LOCK : ( node?.data?.status === 'CLD' ? COLOR_CHILD_LOCK : COLOR_OTHER_LOCK);
        return ( 
            (node?.data?.status === 'OWN' || node?.data?.status === 'LCK' || node?.data?.status === 'CLD') &&
            <Box sx={{padding: 0, margin: 0, paddingLeft: '3em', color: color, textAlign: 'left', width: '100%'}}> 
                <Tooltip title={label}>
                    <LockIcon fontSize="18px"/>
                </Tooltip>
            </Box>
        );
    };

    // <Typography sx={{display: 'inline'}}>{node?.data?.label}</Typography>

    const labelTemplate = (node,options) => {
        return ( node?.data?.type === 'INST' ?
            <Button variant="text" onClick={() => openInstance(node)} sx={{color: 'rgba(0,0,0,0.87)'}}>{node?.data?.label}</Button> :
            <Button variant="text" onClick={() => toggleNode(node)} sx={{color: 'rgba(0,0,0,0.87)'}}>{node?.data?.label}</Button>
        );
    };


    return (
        <Box sx={{padding: 2,  overflow: 'hidden'}}>
            
            <Box sx={{ overflow: 'hidden'}}>
                <TreeTable value={workNodes} tableStyle={{ width: '100%', overflowY: 'auto'}} emptyMessage={<span></span>}
                    
                    selectionKeys={selectedNodeKey} expandedKeys={expandedKeys} onToggle={handleToggleNode}
                    selectionMode="single" onSelectionChange={handleSelectedNodeKey} onSelect={handleSelectedNode} metaKeySelection={false} 
                    scrollable scrollHeight={'' + tableHeight + 'px'} overflow="auto"
                    defaultSortOrder={0} rowHover >
                    <Column body={labelTemplate} header="Workflows" alignHeader="left" style={{ padding: 0, paddingLeft: '1ex', textAlign: 'left', width: '60%' }}
                        headerStyle={{ padding: '0.9ex', width: '60%', fontSize: '90%' }} 
                        bodyStyle={{textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '60%', padding: CELL_PADDING,}}
                        expander ></Column>
                    <Column header="Current Status" align="left" headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'left', }} bodyStyle={{padding: CELL_PADDING, textAlign: 'left'}} body={statusTemplate}></Column>
                </TreeTable>
            </Box>
        </Box>
    );

}

function RuntimeWorkflows(props) {

    const {
        readOnly=false,
        ...other
    } = props;

    const [updateDef, setUpdateDef] = useState(0);
    const [updateDefId, setUpdateDefId] = useState(-1);

    const [updateWorkflowInstance, setUpdateWorkflowInstance] = useState(0);

    const [workflowList, setWorkflowList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [contextMenu, setContextMenu] = useState(null);
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [editEnabled, setEditEnabled] = useState(false);
    const [createEnabled, setCreateEnabled] = useState(true);

    const [workflowDeleteOpen, setWorkflowDeleteOpen] = useState(false);
    const [workflowCreateOpen, setWorkflowCreateOpen] = useState(false);
    const [workflowEditOpen, setWorkflowEditOpen] = useState(false);
    const [statusOpen, setStatusOpen] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [statusSeverity, setStatusSeverity] = useState('success');

    const selectedNode = useSelector((state) => state.runtime.instanceNode);
    

    const theme = useTheme();

    React.useEffect(() => {
        console.log('Runtime readOnly = ' + readOnly);
        setCreateEnabled(!readOnly);
    }, [readOnly]);

    React.useEffect(() => {
        /*
        if (updateDefId >= 0) {
            netGet('/api/workflow/def/' + updateDefId)
                .then(response => response.json())
                .then(def => {
                    if (def && def.id) {
                        console.log('Updating Workflow Definition: ' + def.id);
                        let slist = workflowList.map((r) => {
                            if (r.id === def.id) {
                                return def;
                            }
                            return r;
                        });
                        setWorkflowList(slist);
                    }
                }).catch(error => {
                    console.log(`Error fetching def for ${updateDefId}: ${error}`);
                });
        }
        */
    }, [updateDef,updateDefId]);

    useEffect( () => {
        if ( selectedNode?.key ) {
            setDeleteEnabled(!readOnly);
            setEditEnabled(!readOnly);
        } else {
            setDeleteEnabled(false);
            setEditEnabled(false);
        }
    }, [selectedNode]);


    const workflowMessage = (message) => {
        let wevent = message.data;
        console.log('Received workflow message: ' + wevent.action + ' : ' + wevent.type + ' : ' + wevent.id);
        
        if (wevent.type === 'WorkflowInstance') {
            if ( wevent.action === 'DELETE' || wevent.action === 'NEW' || wevent.action === 'MODIFIED') {
                setUpdateWorkflowInstance(updateWorkflowInstance => updateWorkflowInstance + 1);
            }
        }
        
    };

    MessageHooks["workflow"]["WorkflowInstance"] = workflowMessage;


    const handleContextMenu = (event,index) => {
        event.preventDefault();
        setContextMenu(
          contextMenu === null
            ? {
                mouseX: event.clientX + 2,
                mouseY: event.clientY - 6,
              }
            : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
              // Other native context menus might behave different.
              // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
              null,
        );
        if ( index >= 0 ) {
            handleItemClick(index);
        }
    };

    const handleContextMenuClose = () => {
        setContextMenu(null);
    };

    const handleItemClick = (index) => {
        setSelectedIndex(index);
        if ( index >= 0 ) {
            setDeleteEnabled(true);
            setEditEnabled(true);
        } else {
            setDeleteEnabled(false);
            setEditEnabled(false);
        }
    };

    const isLockedByMe = (index) => {
        let def = workflowList[index];
        return typeof def.user === 'string' && def.user.length > 0 && def.user === UserInfo.info.name;
    };

    const isLocked = (index) => {
        let def = workflowList[index];
        return typeof def.user === 'string' && def.user.length > 0;
    };


    
    const handleDeleteWorkflowAction = () => {
        handleContextMenuClose();
        setWorkflowDeleteOpen(true);
        /*
        const workflow = workflowList[selectedIndex];
        setWorkflowRetractName(workflow.label);
        setWorkflowRetractOpen(true);
        */
    };

    const deleteWorkflowSave = (inst) => {
        setWorkflowDeleteOpen(false);
        setStatusSeverity('error');
        // console.log("DELETE inst.id = " + inst.data?.instance?.id);
        // console.log("DELETE inst = " + JSON.stringify(inst));
        const label = inst.data?.label ? `"${inst.data.label}"` : ''
        setStatusMessage(`Deleted workflow ${label}`);
        setStatusOpen(true);
        serverDelete(inst);
        /*
        const workflow = workflowList[selectedIndex];
        serverRetract(workflow);
        */
    };

    const serverDelete = (inst) => {
        if (inst.data?.instance?.id) {
            netFetch('/api/workflow/inst/' + inst.data.instance.id, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + keycloak.token
                }
            })
                .then(resp => {
                    if (!resp.ok) {
                        console.log('Could not delete workflow instance: status = ' + resp.status);
                    }
                });
        }
    };

    const deleteWorkflowCancel = () => {
        setWorkflowDeleteOpen(false);
    };

    const handleCreateWorkflowAction = () => {
        handleContextMenuClose();
        setWorkflowCreateOpen(true);
    };

    const createWorkflowSave = (newLabel, newDescription, instanceName, workflow, docid, part, roleMemberMap) => {
        setWorkflowCreateOpen(false);
        setStatusSeverity('success');
        const label = instanceName && instanceName.trim().length > 0 ? `"${newLabel}—${instanceName}"` : `"${newLabel}"`;
        setStatusMessage(`Created workflow ${label}`);
        setStatusOpen(true);
        serverStart(workflow, newLabel, newDescription, instanceName, docid, part);
    }

    const serverStart = (def, label, description, instance, docid, part, roleMemberMap) => {
        let info = {
            definition: def
        };
        if (label) {
            info['label'] = label;
        }
        if (description) {
            info['description'] = description;
        }
        if (instance) {
            info['instance'] = instance;
        }
        if (docid && docid !== 'NONE' && docid !== '') {
            info['document'] = docid;
        }
        if (part) {
            info['part'] = part;
        }
        if ( roleMemberMap ) {
            info['properties'] = { roleMemberMap: roleMemberMap} ;
        }
        console.log('Creating workflow instance with params: ' + JSON.stringify(info));
        netPost('/api/workflow/inst/start', info)
            .then(resp => {
                if (!resp.ok) {
                    console.log('Could not start workflow: status = ' + resp.status);
                }
            });
    };

    const createWorkflowCancel = () => {
        setWorkflowCreateOpen(false);
    }

    const handleEditWorkflowAction = () => {
        setWorkflowEditOpen(true);
    };

    const editWorkflowSave = (inst) => {
        setWorkflowEditOpen(false);
        netPost('/api/workflow/inst/update', inst)
            .then(resp => {
                if ( !resp.ok ) {
                    console.log('Could not update workflow instance: ' + resp.status);
                }
            });
    };

    const editWorkflowCancel = () => {
        setWorkflowEditOpen(false);
    };
    
    const publishedIconColor = (index) => {
        const def = workflowList[index];
        // console.log('index: ' + index + ', user=' + def.user);
        if ( (def.flag & 2) != 0) {
            return 'black';
        }
        return 'transparent';
    };

    const handleStatusClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setStatusOpen(false);
        // setStatusMessage('');
        // setStatusSeverity('success');
    };

    return (

        <Box sx={{ position: 'relative', width: '100%', height: '100%', padding: '1ex', paddingTop: '2ex', display: 'grid', gridTemplateRows: 'min-content min-content minmax(10px,1fr) min-content' }}>
            <Typography align="center" variant="h7" sx={{ paddingBottom: '2ex', fontWeight: theme.typography.fontWeightBold }}>Workflow Runtime Instances</Typography>
            <Box sx={{textAlign: 'center'}}>
                <TextField
                    id="mwa-search"
                    type="search"
                    size="small"
                    sx={{ maxWidth: '400px' }}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }
                    }}
                />
            </Box>
            <Box
                sx={{ position: 'relative', minHeight: '2em', overflowY: 'auto' }}
                onContextMenu={(event) => handleContextMenu(event, -1)}
            >

                <WorkflowList update={updateWorkflowInstance} />
                {/* 
                <Menu
                    open={contextMenu !== null}
                    onClose={handleContextMenuClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                        contextMenu !== null
                            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                            : undefined
                    }
                >
                    <MenuItem onClick={handleDeleteWorkflowAction} disabled={!deleteEnabled}>Delete</MenuItem>
                     variant="filled"
                </Menu>
                */}
                <WorkflowStartDialog open={workflowCreateOpen} onSave={createWorkflowSave} onCancel={createWorkflowCancel} />
                <WorkflowDeleteDialog open={workflowDeleteOpen} onSave={deleteWorkflowSave} onCancel={deleteWorkflowCancel} />
                <WorkflowEditDialog open={workflowEditOpen} onSave={editWorkflowSave} onCancel={editWorkflowCancel} />
                <Snackbar open={statusOpen} autoHideDuration={3000} onClose={handleStatusClose} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}} >
                    <Alert
                        onClose={handleStatusClose}
                        severity={statusSeverity}
                       
                        sx={{ width: '100%' }}
                    >
                        {statusMessage}
                    </Alert>
                </Snackbar>
            </Box>
            <Box sx={{ padding: '1ex', paddingRight: '2ex', whiteSpace: 'nowrap', overflowX: 'hidden' }} color={theme.palette.primary.main}>
                <Tooltip title="Create Workflow Instance">
                    <Button variant="outlined" startIcon={<AddBoxIcon fontSize="inherit" color={createEnabled ? "success" : "gray"} />} disabled={!createEnabled} 
                        onClick={handleCreateWorkflowAction}>
                        Create
                    </Button>
                </Tooltip>
                <Tooltip title="Edit Workflow Instance">
                    <Button variant="outlined" startIcon={<EditIcon fontSize="inherit" color={editEnabled ? "secondary" : "gray"} />} disabled={!editEnabled} 
                        onClick={handleEditWorkflowAction} sx={{marginLeft: 2}}>
                        Edit
                    </Button>
                </Tooltip>
                <Tooltip title="Delete Workflow Instance">
                    <Button variant="outlined" startIcon={<DeleteIcon fontSize="inherit" color={deleteEnabled ? "error" : "gray"} />} disabled={!deleteEnabled} 
                        onClick={handleDeleteWorkflowAction} sx={{marginLeft: 3}}>
                        Delete
                    </Button>
                </Tooltip>
                
            </Box>
        </Box>


    );

}


export { RuntimeWorkflows, };